import {
    AutoComplete,
    DigitText,
    Email,
    FileUpload,
    PicUpload,
    DataBlock,
    LookUp,
    LookUpV2,
    PopArea,
    PopTree,
    TextAreaCompoent,
    TextBox,
    Url,
    Staff,
    Button,
    ChooseComponent,
    DigitalInterval, // 数字区间组件
    DatePicker,
    DateRange,
    RichEditor,
    FormulaTextarea,
    NextApprover,
    JumpToSpecify,
    TiledSelect,
    SingleSelectGroup
} from '../Field_Components';

import FormPart from './FormPart';

class FieldMap {
    constructor() {
        this.map = {
            BC_AutoComplete: AutoComplete,
            BC_CheckBoxList: ChooseComponent, //PopCheckboxList,
            BC_Time: DatePicker,
            BC_DateTime: DatePicker,
            BC_Date: DatePicker,
            BC_TimeRange: DateRange,
            BC_DateTimeRange: DateRange,
            BC_DateRange: DateRange,
            BC_YearsRange: DateRange,
            BC_DigitText: DigitText, //小数
            BC_Email: Email,
            BC_DropDownList: ChooseComponent,
            BC_FileUploader: FileUpload,
            BC_LookUp: LookUp,
            BC_LookUpV2: LookUpV2,
            BC_PictureUploader: PicUpload,
            BC_PopArea: PopArea,
            BC_PopCheckboxList: ChooseComponent,
            BC_PopRadioList: ChooseComponent,
            BC_PopTree: PopTree,
            BC_SingleDepartment: PopTree,
            BC_SingleDepartmentSearch: PopTree,
            BC_RadioList: ChooseComponent,
            BC_TextArea: TextAreaCompoent,
            BC_TextAreaRTF: RichEditor, //富文本
            BC_TextBox: TextBox,
            BC_TextBoxRange: DigitalInterval,
            BC_Url: Url,
            BC_Staff: Staff,
            BC_UserSelect: Staff,
            BC_Button: Button,
            FormPart: FormPart,
            BC_DataBlockList: DataBlock,
            BC_Formula: FormulaTextarea,
            BC_JumpTo: JumpToSpecify,
            BC_NextApprover: NextApprover,
            BC_TiledSelect: TiledSelect, //平铺单选、多选
            BC_SingleSelectGroup: SingleSelectGroup //单选组
        };
        //区间组件
        this.mapInterval = {
            BC_Time: DateRange,
            BC_DateTime: DateRange,
            BC_Date: DateRange,
            BC_DigitText: DigitalInterval
        };
        this.noWrappField = ['BC_FileUpload', 'BC_PictureUploader'];
    }

    registerComponent(key, cmp) {
        this.map[key] = cmp;
    }

    getComponentMap(opeartor) {
        if (opeartor === 'range') {
            return Object.assign({}, this.map, this.mapInterval);
        } else {
            return this.map;
        }
    }

    getNoWrapComponents() {
        return this.noWrappField;
    }
}

const FieldMapInstance = new FieldMap();

export default FieldMapInstance;



// WEBPACK FOOTER //
// ./src/components/Form/FieldMap.js